import { render, staticRenderFns } from "./AnnotationsList.vue?vue&type=template&id=ba23daac&"
import script from "./AnnotationsList.vue?vue&type=script&lang=js&"
export * from "./AnnotationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports